<script lang="ts">
	import { onMount } from "svelte";
	import Hydrator from "@reperio-news/core.components/Hydrator.svelte";
	import ContentItem from "../ContentItem/Default.svelte";

	export let id: string;
	export let globalId: string;
	export let globalSource: number;
	// ignore no use
	id || globalId || globalSource;

	export let data = {};

	let article = null;
	let date = new Date();

	const months = [
		"Ianuarie",
		"Februarie",
		"Martie",
		"Aprilie",
		"Mai",
		"Iunie",
		"Iulie",
		"August",
		"Septembrie",
		"Octombrie",
		"Noiembrie",
		"Decembrie",
	];

	const days = [
		1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
		21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
	];

	let abortController = null;

	async function getData(): Promise<any> {
		function addLeadingZeros(num: number, totalLength: number) {
			return String(num).padStart(totalLength, "0");
		}

		const pars = {
			tags: [
				`calendar:${date.getDate()}.${date.getMonth() + 1}`,
				`calendar:${addLeadingZeros(
					date.getDate(),
					2
				)}.${addLeadingZeros(date.getMonth() + 1, 2)}`,
			],
			sort: {
				last_published_at: "desc",
			},
			limit: 1,
		};

		abortController = new AbortController();
		const signal = abortController.signal;

		const res = await fetch(
			`/content.json?query_json=${encodeURIComponent(
				JSON.stringify(pars)
			)}`,
			{
				signal,
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			}
		);

		const { items } = await res.json();
		return items.pop();
	}

	onMount(async () => {
		if (__ADMIN__) {
			return;
		}

		date = new Date();
		article = await getData();
	});

	let currentyLoading: "day" | "month" = null;

	async function change(
		type: "day" | "month",
		direction: number
	): Promise<void> {
		if (currentyLoading) {
			abortController.abort();
		}

		const t = type === "day" ? 86400000 : 2678400000;

		let cd = null;
		if (type === "month") {
			cd = date.getDate();
		}

		date = new Date(date.getTime() + t * direction);
		date.setHours(0, 0, 0, 1);
		if (cd) {
			date.setDate(cd);
		}
		currentyLoading = type;
		let setArticle = null;
		try {
			setArticle = await getData();
		} catch (e) {
			console.log(e);
		}

		setTimeout(() => {
			article = setArticle;
			currentyLoading = null;
		}, 250);
	}
</script>

<Hydrator props={$$props} component="Calendar" hydrate={!__ADMIN__}>
	<div class="container">
		<h2>🗓️ Calendar istoric</h2>

		<div class="inside">
			<div class="article" class:animated-article={currentyLoading}>
				{#if article}
					<ContentItem data={{ content: article }} />
				{:else}
					<i>Pe moment n-am găsit nimic pentru această zi.</i>
				{/if}
			</div>

			<div class="form">
				<div class="day" class:animated={currentyLoading === "day"}>
					<div class="left" on:click={() => change("day", -1)}>
						&larr;
					</div>
					{date.getDate()}
					<div class="right" on:click={() => change("day", 1)}>
						&rarr;
					</div>
				</div>

				<div class="month" class:animated={currentyLoading === "month"}>
					<div class="left" on:click={() => change("month", -1)}>
						&larr;
					</div>
					{months[date.getMonth()]}
					<div class="right" on:click={() => change("month", 1)}>
						&rarr;
					</div>
				</div>
			</div>
		</div>
	</div>
</Hydrator>

<style lang="scss">
	.container {
		background-color: rgb(231, 225, 225);
		padding: 10px;
		min-height: 446px;
		width: calc(100% - 20px);
		margin: auto;

		h2 {
			width: calc(100% - 20px);
			margin: 0 0 10px 10px;
			border-bottom: 2px solid #111;
		}

		.inside {
			display: flex;
			justify-content: center;
			align-items: center;
			flex-wrap: wrap;
			min-height: 378px;

			.article {
				width: 50%;
				display: flex;
				justify-content: center;
				align-items: center;
			}

			.animated-article {
				transition: all 150ms ease-in-out;
				filter: grayscale(100%);
			}

			.form {
				width: calc(50% - 10px);
				padding: 5px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-wrap: wrap;
				user-select: none;
				flex-direction: column;

				.day,
				.month {
					font-size: 65px;
					margin-right: 40px;
					margin-bottom: 40px;
					box-shadow: 5px 5px 0px 0px #858f58,
						10px 10px 0px 0px #7d855a, 15px 15px 0px 0px #6c7059,
						20px 20px 0px 0px #4d5237, 25px 25px 0px 0px;
					display: flex;
				}

				@keyframes animateBoxShadow {
					from {
						box-shadow: 5px 5px 0px 0px #858f58,
							10px 10px 0px 0px #7d855a, 15px 15px 0px 0px #6c7059,
							20px 20px 0px 0px #4d5237, 25px 25px 0px 0px;
					}

					to {
						box-shadow: 5px 5px 0px 0px #69674a,
							10px 10px 0px 0px #666441, 15px 15px 0px 0px #666227,
							20px 20px 0px 0px #3b3809, 25px 25px 0px 0px;
					}
				}

				.animated {
					animation-duration: 0.5s;
					animation-name: animateBoxShadow;
					animation-iteration-count: infinite;
					animation-direction: alternate;
					.left,
					.right {
						opacity: 0.1;
						transition: opacity 0.1s ease-in-out;
					}
				}

				.day {
					font-weight: bold;
				}

				.left,
				.right {
					cursor: pointer;
					color: rgb(65, 61, 61);
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.container {
			.inside {
				flex-direction: column-reverse;

				.article {
					width: 100%;
				}

				.form {
					width: 100%;

					.day,
					.month {
						font-size: 25px;
					}
				}
			}
		}
	}
</style>
